<template>
  <div>
    <h3 class="header">{{title}}</h3>
    <div class="title">
      <div style="font-size:12px;margin:10px;color:gray">{{desc}}</div>
      <van-cell-group style="display:flex;align-items:center"
                      v-for="(item,index) in question.linkman"
                      :key="index">
        <van-field :label="item.showname"
                   size="large"
                   clearable
                   v-model="item.content"
                   :placeholder="'请输入'+item.showname"
                   :required="item.required" />
      </van-cell-group>
      <h5 style="font-size:14px">{{questions}}</h5>
      <van-checkbox-group v-model="multi"
                          @change="change"
                          v-for="(item,index) in items"
                          :key="index">
        <van-checkbox :disabled="item.disabled"
                      :name="item.id"
                      class="radio">
          <span style="font-weight:blod;">{{item.id}}.</span>
          <span style="font-size:16px"> {{item.item}}</span>
          <span style="color:gray;font-size:14px">{{item.ext}}</span>
        </van-checkbox>
      </van-checkbox-group>

      <br />

      <div style="display:flex;justify-content: center;">
        <van-button type="primary"
                    class="submit"
                    @click="submitAnswer"
                    :disabled="disabled">提交答案</van-button>
      </div>
      <div class="footer">
        <!-- 吉林银行专属客户经理 -->
        <br />
        {{ad}}
        <br />@锐道咨询
      </div>
    </div>
  </div>
</template>

<script>
import { wxzhuzi, wenjuan } from '../api/wenjuan'

export default {
  data() {
    return {
      disabled: false,
      multi: [],
      items: [],

      title: '',
      questions: '',
      desc: '',
      ad: '',
      question: {
        id: '',
        answer: [],
        linkman: [
          {
            filed: '',
            content: ''
          }
        ]
      }
    }
  },
  methods: {
    change(val) {
      this.question.answer = val
    },
    submitAnswer() {
      this.disabled = true
      this.$http
        .post('/oa/wxzhuzi/multi_wenjuan', this.question)
        .then((res) => {
          if (res.data.code == 200) {
            this.$toast({
              message: res.data.message,
              type: 'success',
              duration: 10000
            })
            this.question = {}
            this.multi = []
            this.disabled = false
          } else {
            this.$toast({
              message: res.data.message,
              type: 'waring',
              duration: 10000
            })
            this.disabled = false
          }
        })
    }
  },
  created() {
    if (this.$route.query.id) {
      var id = this.$route.query.id
      this.$http.post('/oa/wxzhuzi/multi_index?id=' + id).then((res) => {
        this.items = res.data.data.items
        this.title = res.data.data.title
        this.questions = res.data.data.question
        this.desc = res.data.data.desc
        this.ad = res.data.data.ad
        this.question.id = res.data.data.id
        this.question.linkman = JSON.parse(res.data.data.linkman)

        console.log(this.linkman)
        // if (this.linkman.username) {
        //   this.a = true;
        // }

        // if (this.linkman.branch) {
        //   this.b = true;
        // }

        // if (this.linkman.dep) {
        //   this.c = true;
        // }

        // if (this.linkman.mobile) {
        //   this.d = true;
        // }
      })
    } else {
      const id = 2
      this.$http.post('/oa/wxzhuzi/multi_index?id=' + id).then((res) => {
        console.log('1n')
        this.items = res.data.data.items
        this.title = res.data.data.title
        this.questions = res.data.data.question
        this.question.id = res.data.data.id
        this.$route.query.id = res.data.data.id
        this.linkman = JSON.parse(res.data.data.linkman)

        if (this.linkman.username) {
          this.a = true
        }

        if (this.linkman.branch) {
          this.b = true
        }

        if (this.linkman.dep) {
          this.c = true
        }

        if (this.linkman.mobile) {
          this.d = true
        }
      })
    }
  }
}
</script>

<style scoped>
.title {
  width: 90%;
  margin: 0 0 0 20px;
  font-size: 12px;
}
.header {
  width: 100%;
  text-align: center;
  margin: 10px 0 0 0;
}
.radio {
  margin: 20px 0 0 0;
}
.submit {
  border-radius: 10px;

  width: 100px;
  height: 40px;
}
.margin {
  margin: 10px;
}
.footer {
  text-align: center;
  color: gray;
  font-size: 14px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mine.vue